// extracted by mini-css-extract-plugin
export default {"edit":"edit_edit__zlyBf","header":"edit_header__GynYg","rotate":"edit_rotate__zTH8H"};